import { ReanalysisFragment } from '@spotify/confidence-graphql';
import {
  getIsEditDisabled,
  moduleHelpers,
} from '@spotify/plugin-confidence-workflows';

import { ReAnalysisData } from './ReanalysisModule/types';

export const isEditDisabled = getIsEditDisabled(['archived']);

export const tabForState = (
  workflowInstance: Pick<ReanalysisFragment, 'moduleData'>,
) => {
  const reanalysisData = moduleHelpers.getModuleData<ReAnalysisData>(
    workflowInstance.moduleData,
    'reanalysis',
  );

  const showResults =
    !reanalysisData?.configChanged &&
    reanalysisData?.exposureState &&
    reanalysisData?.exposureState !== 'STATE_UNSPECIFIED';
  return showResults ? 'result' : 'design';
};
